import API from '../../sunwiseAPI';

const config = { headers: { 'Content-Type': 'application/json' } };
const ENTITY = 'historical';

export const create = (data) =>
    API.post(`/api/v1/${ENTITY}/sunpay/`, data, config);
export const fetchData = (projectId) =>
    API.get(`/api/v1/${ENTITY}/${projectId}/sunpay/`);
export const fetchPaginatedData = (project_id, page, page_size, year) =>
    API.get(`/api/v1/paginated-${ENTITY}/sunpay/`, {
        params: { page, page_size, project_id, year },
    });
export const fetchPriceData = (projectId, report) =>
    API.get(`/api/v1/${ENTITY}-reporter/${projectId}/sunpay`, {
        params: { report },
    });
export const update = (uuid, data) =>
    API.put(`/api/v1/${ENTITY}/${uuid}/sunpay/`, data, config);
export const deleteItem = (uuid) =>
    API.delete(`/api/v1/${ENTITY}/${uuid}/sunpay/`);
